import React from 'react';
import { withRouter, Switch, Route, useSearchParams, BrowserRouter} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import './tailwind.css';
import { useAnalytics } from './hooks/useAnalytics';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';
import LayoutAlternative from './layouts/LayoutAlternative';
import LayoutAlt2 from './layouts/LayoutAlt2';
import LayoutSignin from './layouts/LayoutSignin';
import LayoutPlain from './layouts/LayoutPlain';
import LayoutPlainHeader from './layouts/LayoutPlainHeader';

// Views 
import Home from './views/Home';
import Curriculum from './views/Bootcamp';
import Symposium from './views/Research';
import AcceptanceResearch from './views/Acceptance-Research';
import RejectResearch from './views/Reject-Research';
import Login from './views/temp';
import Team from './views/Team';
import PR from './views/PR';
import ResearchApplication from './views/ResearchApplication';
import ResearchAcceptWithPayment from './views/ResearchAcceptWithPayment';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedInUser: null,
      fullName: ''
    };

  }
  setFullName = (fullName) => {
    this.setState({ fullName });
  }

  componentDidMount() {
    document.body.classList.add('is-loaded')
    this.refs.scrollReveal.init();
    // this.scrollRevealRef.current.init();
    // this.init();

  }

  // Route change
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.refs.scrollReveal.init();
      // this.scrollRevealRef.current.init();
      // this.init();
      // console.log('Route changed:', this.props.history);
    }
  }

  render() {
    return (
      <BrowserRouter>
        <HelmetProvider>
          <AnalyticsWrapper>
            <ScrollReveal
              ref="scrollReveal"
              children={() => (
                <Switch>
                  <AppRoute exact path="/" component={Home} layout={LayoutDefault} canonicalUrl="https://blastai.org/" />
                  <AppRoute exact path="/bootcamp" component={Curriculum} layout={LayoutAlternative} canonicalUrl="https://blastai.org/bootcamp" />
                  <AppRoute exact path="/research" component={Symposium} layout={LayoutAlternative} canonicalUrl="https://blastai.org/research" />
                  <AppRoute exact path="/testimonials" component={PR} layout={LayoutDefault} canonicalUrl="https://blastai.org/testimonials" />
                  <AppRoute exact path="/team" component={Team} layout={LayoutDefault} canonicalUrl="https://blastai.org/team" />

                  <Route exact path="/temp">
                    <Login onLogin={this.onLogin} />
                  </Route>

                  <AppRoute exact path="/apply-research" component={ResearchApplication} layout={LayoutPlain} canonicalUrl="https://blastai.org/apply" />
                  {/* <AppRoute exact path="/apply" component={ResearchApplication} layout={LayoutPlain} canonicalUrl="https://blastai.org/apply" /> */}

                  <AppRoute path="/letter/:userId" component={AcceptanceResearch} layout={LayoutAlt2}/>
                  <AppRoute path="/decision/:userId" component={RejectResearch} layout={LayoutAlt2}/>
                  <AppRoute path="/commit/:userId" component={ResearchAcceptWithPayment} layout={LayoutAlt2}/>

                  <Route path='/apply-fa-23' component={() => {
                    window.location.href = '/apply';
                    return null;
                  }}/>
                  <Route path='/applyfall23' component={() => {
                    window.location.href = '/apply';
                    return null;
                  }}/>
                  
                  <Route path='/bootcamp-application' component={() => {
                    window.location.href = 'https://forms.gle/aX4j2ZZfU1Q4b9pN8';
                    return null;
                  }}/>
                  <Route path='/research-application' component={() => {
                    window.location.href = 'apply';
                    return null;
                  }}/>
                  <Route path='/hiring' component={() => {
                    window.location.href = 'https://airtable.com/appjqjUChqruvhQaS/pag2uWtHvW71PTUHx/form';
                    return null;
                  }}/>
                  <Route path='/blastoff-2025-accept' component={() => {
                    window.location.href = 'https://wnewxg7rxr5.typeform.com/to/It50iMMJ';
                    return null;
                  }}/>
                  <Route path='/financial-aid-application' component={() => {
                    window.location.href = 'https://forms.gle/ppZKduUegpyjbHgGA';
                    return null;
                  }}/>
                  <Route path='/apply-to-blast' component={() => {
                    window.location.href = 'apply';
                    return null;
                  }}/>
                </Switch>
              )} />
          </AnalyticsWrapper>
        </HelmetProvider>
      </BrowserRouter>
    );
  }
}

// Analytics wrapper component
const AnalyticsWrapper = ({ children }) => {
  useAnalytics();
  return children;
};

export default withRouter(props => <App {...props} />);
